// extracted by mini-css-extract-plugin
export default {"mian_content":"mian_content__Main___YFtvoU4cpg"};